module.exports = __webpack_public_path__ + "static/media/layout1-img.1dd3521c.svg";